import styled from 'styled-components';
import { mixins } from '@sy/component-library';

import {
	POSTS_PER_ROW_BELOW_MEDIUM,
	POSTS_PER_ROW_BELOW_LARGE,
	POSTS_PER_ROW_ABOVE_LARGE,
	RELATED_POSTS_GRID_GAP,
	RELATED_POSTS_MAX_WIDTH,
	RELATED_POSTS_VIEWPORT_WIDTH,
	RELATED_POSTS_VERTICAL_PADDING,
} from './constants';

const { media } = mixins;

export const StyledBlogPost = styled.article`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin: auto;
	max-width: 888px;
	padding: 0 20px;

	${media.belowLarge`
		justify-content: center;
	`}
`;

export const StyledMain = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 700px;
`;

export const StyledRelatedPosts = styled.section`
	align-items: center;
	border-top: ${({ theme }) => `2px solid ${theme.colors.grey[120]}`};
	display: flex;
	flex-direction: column;
	margin: auto;
	max-width: ${RELATED_POSTS_MAX_WIDTH}px;
	padding: 40px 0 96px;
`;

export const StyledRelatedPostsTitle = styled.h1`
	font-size: 3.2rem;
	font-weight: 700;
	line-height: 1.1875;
	margin-bottom: 64px;
	text-align: center;
`;

export const StyledRelatedPostsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: ${RELATED_POSTS_GRID_GAP}px;
	justify-content: center;
	width: ${RELATED_POSTS_VIEWPORT_WIDTH}%;

	${media.belowLarge`
		padding: 0 ${RELATED_POSTS_VERTICAL_PADDING}px;
	`}

	& > * {
		max-width: calc(${100 / POSTS_PER_ROW_ABOVE_LARGE}% - 16px);
		width: 100%;

		${media.belowLarge`
			max-width: calc(${100 / POSTS_PER_ROW_BELOW_LARGE}% - 12px);
		`}

		${media.belowMedium`
			max-width: ${100 / POSTS_PER_ROW_BELOW_MEDIUM}%;
		`}
	}
`;
